import * as d3 from 'd3'

export default {
  methods: {

    open_Window(selection, props) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).style('opacity', props.target == 'Diagram' ? .4 : 1)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).style('opacity', props.target == 'Diagram' ? 1 : .4)
      })
      .on('click', () => {
        this.draw_Window(props)
      })
    },


    draw_Window(props) {
    
      let popWidth = (this.Canvas.CanvasWidth - props.width) / 2
      let popHeight = (this.Canvas.CanvasHeight - props.height) / 2

      this.canvasPupup = this.svg
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .style('font-family', 'roboto').attr('cursor', 'default').attr('opacity', 1)

      this.canvasPupup
      .append('rect')
      .attr('width', this.Canvas.CanvasWidth).attr('height', this.Canvas.CanvasHeight).attr('fill', '#fff').attr('opacity', .8)

      let win = this.canvasPupup
      .append('g')
      .attr('transform', `translate(${popWidth}, ${popHeight})`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      win
      .append('rect')
      .attr('rx', 10).attr('ry', 10)
      .attr('width', props.width).attr('height', props.height)
      .attr('fill', '#fff').attr('stroke', '#000').attr('stroke-width', .5).attr('stroke', 1)
      .attr('filter', 'url(#dropShadow)').style('opacity', .5)

      win
      .append('rect')
      .attr('rx', 10).attr('ry', 10)
      .attr('width', props.width).attr('height', 60).attr('fill', `url(#${this.localId}_LightBlue_H2)`)

      win
      .append('rect')
      .attr('y', 45).attr('fill', '#fff').attr('width', props.width).attr('height', props.height-65)

      props.exeFunc(win, props)
    },


    call_Closed(selection) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).style('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).style('opacity', 1)
      })
      .on('click', () => {
        this.close_Window()
      })
    },


    close_Window() {
      this.canvasPupup.transition().duration(500).attr('opacity', 0)
      setTimeout(() => {
        this.canvasPupup.remove()
      }, 500)
    },


    reflash(crt, y) {
      d3.select('#CRT_ID').text(crt.id)
      d3.select('#CRT_COUNT').text(crt.count)
    },
  }
}